window.GameCourseData = JunctionCourseData.extend({
    createCourseData: function(xml) {
        JunctionCourseData.prototype.createCourseData.call(this, xml);
        this.filterQuestions();
    },

    filterQuestions: function() {
        var module = this.getModule(0);
        module.pages = this.randomizeQuestions(module.pages);
    },

    randomizeQuestions: function(pages) {
        var randomizedPages = this.container.tracking.getItem(GameCourseData.RANDOMIZED_PAGES);
        if (randomizedPages == -1) {
            if (this.container.isLocked) pages = _.shuffle(pages);

            var rPagesStr = "";
            _.each(pages, function(page, i) {
                page.pageNumber(i);
                Logger.info("Selected-->", page.pageID());
                if (i === 0) {
                    rPagesStr += page.pageID();
                } else {
                    rPagesStr += GameCourseData.PAGE_SPLITTER + page.pageID();
                }
            });
            this.container.tracking.setItem(GameCourseData.RANDOMIZED_PAGES, rPagesStr);
        } else {
            var count = 0;
            var finalPages = [];
            var rPages = randomizedPages.split(GameCourseData.PAGE_SPLITTER);
            _.each(rPages, function(rPage) {
                var pageID = rPage;
                _.each(pages, function(page) {
                    if (pageID === page.pageID()) {
                        Logger.info("Already selected -->", pageID);
                        page.pageNumber(count);
                        finalPages.push(page);
                        count++;
                    }
                }, this);
            });
            pages = finalPages;
        }

        return pages;
    }
}, {
    PAGE_SPLITTER: "$$",
    RANDOMIZED_PAGES: "randomizedPages"
});
